export default "__VITE_ASSET__me7csj5P__"